import { Component, ChangeDetectionStrategy, Injector } from '@angular/core';
import { NavMenuComponent } from './components/nav-menu/nav-menu.component';
import { FooterComponent } from './components/footer/footer.component';
import { RouterModule, Routes } from '@angular/router';
import { ToastsComponent } from './shared-module/components/toasts/toasts.component';
import { AuthGuard } from './shared-module/guards/auth.guard';
import { PrivacyPolicyComponent } from './components/privacy-policy/privacy-policy.component';
import { UnauthorizedComponent } from './components/unauthorized/unauthorized.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { TermsOfUseComponent } from './components/terms-of-use/terms-of-use.component';
import { ComingSoonComponent } from './shared-module/components/coming-soon/coming-soon.component';
import { AppInjectorService } from './app-injector.service';
import { ManagementsComponent } from './components/managements/managements.component';
import { ErrorComponent } from './components/error/error.component';

export const APP_ROUTES: Routes = [
  {
    path: '',
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      { path: 'privacy-policy', component: PrivacyPolicyComponent },
      { path: 'terms-of-use', component: TermsOfUseComponent },
      // { path: 'help-desk', component: HelpDeskComponent }, // We use Jasper.
      { path: 'today-market-data', component: ComingSoonComponent }  ,
      {
        path: 'dashboard',
        canActivate: [AuthGuard],
        loadChildren: () => import('./dashboard-module/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: '',
        canActivate: [AuthGuard],
        loadChildren: () => import('./home-module/home.module').then(m => m.HomeModule)
      },
      {
        path: 'managements',
        component: ManagementsComponent
      },
    ]
  },
  {
    path: '',
    loadChildren: () => import('./auth-module/auth.module').then(m => m.AuthModule)
  },
  {
    path: '',
    canActivate: [AuthGuard],
    loadChildren: () => import('./account-module/account.module').then(m => m.AccountModule)
  },
  {
    path: '',
    canActivate: [AuthGuard],
    loadChildren: () => import('./users-module/users.module').then(m => m.UsersModule)
  },
  {
    path: '',
    canActivate: [AuthGuard],
    loadChildren: () => import('./roles-module/roles.module').then(m => m.RolesModule)
  },
  {
    path: '',
    canActivate: [AuthGuard],
    loadChildren: () => import('./loans-closed-module/loans-closed.module').then(m => m.LoansClosedModule)
  },
  {
    path: '',
    canActivate: [AuthGuard],
    loadChildren: () => import('./loan-officers-module/loan-officers.module').then(m => m.LoanOfficersModule)
  },
  {
    path: '',
    canActivate: [AuthGuard],
    loadChildren: () => import('./processor-module/processor.module').then(m => m.ProcessorModule)
  },
  {
    path: '',
    canActivate: [AuthGuard],
    loadChildren: () => import('./loa-module/loa.module').then(m => m.LoaModule)
  },
  {
    path: '',
    canActivate: [AuthGuard],
    loadChildren: () => import('./funder-module/funder.module').then(m => m.FunderModule)
  },
  {
    path: '',
    canActivate: [AuthGuard],
    loadChildren: () => import('./payroll-module/payroll.module').then(m => m.PayrollModule)
  },
  {
    path: '',
    canActivate: [AuthGuard],
    loadChildren: () => import('./compliance-module/compliance.module').then(m => m.ComplianceModule)
  },
  {
    path: '',
    canActivate: [AuthGuard],
    loadChildren: () => import('./training-portal-module/training-portal.module').then(m => m.TrainingPortalModule)
  },
  {
    path: '',
    canActivate: [AuthGuard],
    loadChildren: () => import('./branch-module/branch.module').then(m => m.BranchModule)
  },
  {
    path: '',
    canActivate: [AuthGuard],
    loadChildren: () => import('./calculator-module/calculator.module').then(m => m.CalculatorModule)
  },
  {
    path: '',
    canActivate: [AuthGuard],
    loadChildren: () => import('./campaign-module/campaign.module').then(m => m.CampaignModule)
  },
  {
    path: '',
    canActivate: [AuthGuard],
    loadChildren: () => import('./lender-module/lender.module').then(m => m.LenderModule)
  },
  {
    path: '',
    canActivate: [AuthGuard],
    loadChildren: () => import('./media-resource-module/media-resource.module').then(m => m.MediaResourceModule)
  },
  {
    path: '',
    canActivate: [AuthGuard],
    loadChildren: () => import('./report-module/report.module').then(m => m.ReportModule)
  }, 
  { path: 'error', component: ErrorComponent },
  { path: 'unauthorized', component: UnauthorizedComponent },
  { path: 'access-denied', component: UnauthorizedComponent },
  { path: '**', component: PageNotFoundComponent },
];


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  imports: [
    NavMenuComponent,
    FooterComponent,
    ToastsComponent,
    RouterModule
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent {

  constructor(
    injector: Injector
  ) { 
    AppInjectorService.setInjector(injector);
  }
}
